var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMainTaskPending = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.93548C14.4569 1.93548 18.0645 5.54238 18.0645 10C18.0645 14.4569 14.4576 18.0645 10 18.0645C5.54306 18.0645 1.93548 14.4576 1.93548 10C1.93548 5.54306 5.54238 1.93548 10 1.93548ZM10 0C4.47714 0 0 4.47714 0 10C0 15.5229 4.47714 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47714 15.5229 0 10 0ZM10 6.77419C8.21843 6.77419 6.77419 8.21843 6.77419 10C6.77419 11.7816 8.21843 13.2258 10 13.2258C11.7816 13.2258 13.2258 11.7816 13.2258 10C13.2258 8.21843 11.7816 6.77419 10 6.77419Z",
    fill: "#731172"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMainTaskPending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/main-task-pending.e56354c0c78961a52a94d0d8c5a4332a.svg";